import * as Yup from 'yup';

import { Alert, Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Field, Formik } from 'formik';
import React, { useState } from 'react';

import CloseButton from '../../Styled/CloseButton';
import ErrorLabel from '../../../ui/ErrorLabel';
import { RadioWrapper } from '../../../ui/Styled';
import cx from 'classnames';
import modalPropTypes from '../../../propTypes/modalPropTypes';
import styled from 'styled-components';

const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #0c1f28;
`;

const StyledFormGroup = styled(Form.Group)`
  padding: 6px 45px 0;
`;

const Step1 = ({ onNext, onHide }) => {
  const [touched, setTouched] = useState(false);

  const onSubmit = async values => {
    try {
      onNext(values);
    } catch (error) {
      addAlert('danger', error.message);
    }
  };

  const schema = Yup.object().shape({
    reason: Yup.mixed()
      .oneOf([
        'no-or-poor-data',
        'cant-add-tariff',
        'better-service-on-different-app',
        'prefer-not-to-say',
        'another-reason',
      ])
      .required(),
    reasonDetail: Yup.string().when('reason', {
      is: 'another-reason',
      then: Yup.string()
        .required('Please provide a reason')
        .matches(
          /^[a-zA-Z\s0-9._\-'",.?!&*%$£#^@()]+$/gm,
          'Please use only alphabetical characters, numbers and punctuation',
        )
        .max(256, 'Please use less than 250 characters'),
    }),
  });

  // TODO: make this reusable
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState(undefined);

  const addAlert = (variant, message) => {
    setShowAlert(true);
    setAlert({ variant, message });
  };

  const hideAlert = () => {
    setShowAlert(false);
    setAlert(undefined);
  };

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onSubmit}
      initialValues={{
        reason: '',
        reasonDetail: '',
      }}
      validateOnChange>
      {({ handleSubmit, isValid, values, isSubmitting }) => (
        <Form onSubmit={handleSubmit}>
          <Container>
            <Row>
              <Col md={10} className="mb-4">
                <h2 className="color-dark">Delete account</h2>
              </Col>
            </Row>
            <Row>
              <Col className="mb-2">
                <Description>
                  Please take a moment to select your main reason for wanting to
                  delete your account:
                </Description>
              </Col>
            </Row>
            {showAlert && alert && (
              <Row>
                <Col className="mb-2">
                  <Alert variant={alert.variant} onClose={() => hideAlert()}>
                    {alert.message}
                    <CloseButton onClick={() => hideAlert()} />
                  </Alert>
                </Col>
              </Row>
            )}
            <Row>
              <Col className="mb-4">
                <Field name="reason">
                  {({ field, meta }) => (
                    <RadioWrapper
                      className={cx({
                        selected: field.value === 'no-or-poor-data',
                      })}>
                      <Form.Check
                        type="radio"
                        name={field.name}
                        id="no-or-poor-data"
                        value="no-or-poor-data"
                        label="I have no data, or poor quality data"
                        onChange={e => {
                          setTouched(true);
                          field.onChange(e);
                        }}
                        onBlur={field.onBlur}
                        className={cx({ error: !!meta.error })}
                      />
                    </RadioWrapper>
                  )}
                </Field>
                <Field name="reason">
                  {({ field, meta }) => (
                    <RadioWrapper
                      className={cx({
                        selected: field.value === 'cant-add-tariff',
                      })}>
                      <Form.Check
                        type="radio"
                        name={field.name}
                        id="cant-add-tariff"
                        value="cant-add-tariff"
                        label="I can't add my tariff"
                        onChange={e => {
                          setTouched(true);
                          field.onChange(e);
                        }}
                        onBlur={field.onBlur}
                        className={cx({ error: !!meta.error })}
                      />
                    </RadioWrapper>
                  )}
                </Field>
                <Field name="reason">
                  {({ field, meta }) => (
                    <RadioWrapper
                      className={cx({
                        selected:
                          field.value === 'better-service-on-different-app',
                      })}>
                      <Form.Check
                        type="radio"
                        name={field.name}
                        id="better-service-on-different-app"
                        value="better-service-on-different-app"
                        label="I can get a better service on a different app"
                        onChange={e => {
                          setTouched(true);
                          field.onChange(e);
                        }}
                        onBlur={field.onBlur}
                        className={cx({ error: !!meta.error })}
                      />
                    </RadioWrapper>
                  )}
                </Field>
                <Field name="reason">
                  {({ field, meta }) => (
                    <RadioWrapper
                      className={cx({
                        selected: field.value === 'prefer-not-to-say',
                      })}>
                      <Form.Check
                        type="radio"
                        name={field.name}
                        id="prefer-not-to-say"
                        value="prefer-not-to-say"
                        label="I prefer not to say"
                        onChange={e => {
                          setTouched(true);
                          field.onChange(e);
                        }}
                        onBlur={field.onBlur}
                        className={cx({ error: !!meta.error })}
                      />
                    </RadioWrapper>
                  )}
                </Field>
                <Field name="reason">
                  {({ field, meta }) => (
                    <RadioWrapper
                      className={cx({
                        selected: field.value === 'another-reason',
                      })}>
                      <Form.Check
                        type="radio"
                        name={field.name}
                        id="another-reason"
                        value="another-reason"
                        label="Another reason"
                        onChange={e => {
                          setTouched(true);
                          field.onChange(e);
                        }}
                        onBlur={field.onBlur}
                        className={cx({ error: !!meta.error })}
                      />

                      {field.value === 'another-reason' && (
                        <Field name="reasonDetail">
                          {({ field, meta }) => (
                            <StyledFormGroup controlId="reason-detail">
                              <Form.Label>My other reason is:</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows="3"
                                placeholder="Please type your reason in here"
                                className={cx({ error: !!meta.error })}
                                {...field}
                              />
                              {meta.error && meta.touched && (
                                <ErrorLabel label={meta.error} />
                              )}
                            </StyledFormGroup>
                          )}
                        </Field>
                      )}
                    </RadioWrapper>
                  )}
                </Field>
              </Col>
            </Row>
            <Row className="mb-2">
              <Col>
                <Button
                  className="w-100"
                  type="submit"
                  variant="primary"
                  disabled={
                    !touched || !values.reason || (!isValid && !isSubmitting)
                  }>
                  Next
                </Button>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  className="w-100"
                  type="button"
                  variant="light"
                  onClick={onHide}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      )}
    </Formik>
  );
};

Step1.propTypes = {
  ...modalPropTypes,
};

export default Step1;
